import { Search } from "@mui/icons-material";
import { Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import batary from "../../assets/svg/batary.svg"; // Battery icon
import CarWosh from "../../assets/svg/CarWosh.icon.svg"; // Car Care icon
import { default as Def, default as defaultImage } from "../../assets/svg/defultImage.svg"; // Import the default image
import galon from "../../assets/svg/galon.Icon.svg"; // Default icon for categories, also used as potential default image in useEffect.
import Tire from "../../assets/svg/Services Icons (2).svg"; // Tire icon
import { newImageUrl } from "../Manufacturers/ManufactureProfile";

function Supplier_Products() {
  const [searchForPermissions, setSearchForPermissions] = useState("");
  const [tableData, setTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const { id } = useParams();
  const { user } = useSelector((state) => state.auth);
  const token = user?.token;

  const getCategoryImage = (categoryName) => {
    switch (categoryName) {
      case "Tire":
        return Tire;
      case "Battery":
        return batary;
      case "Car Care":
        return CarWosh;
      default:
        return galon;
    }
  };

  useEffect(() => {
    const imageUrlBase = "https://estbn.com/EstbnNew/public";

    axios
      .get(`https://estbn.com/EstbnNew/public/api/portal/providers/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log("✅ API response:", response.data);

        // const batches = response.data.data?.provider?.expiring_batches || [];

        // const formatted = batches.map((item) => {
        //   const variation = item.variation;
        //   const product = variation?.product;

        //   // Determine category name based on category_id
        //   let categoryName = "Other";
        //   const categoryId = product?.category_id;
        //   if (categoryId === "10") { // Example IDs - verify these against your backend logic
        //     categoryName = "Battery";
        //   } else if (categoryId === "19") {
        //     categoryName = "Tire";
        //   } else if (categoryId === "...") { // Add more conditions if needed for Car Care, etc.
        //      categoryName = "Car Care"; // Assuming a category ID for Car Care
        //   }

        //   const imageUrl = variation?.profile_image_url
        //     ? `${imageUrlBase}${variation.profile_image_url}`
        //     : galon; // Fallback to galon icon if no specific image URL

        //   return {
        //     id: `#${item.id}`,
        //     ProductName: variation?.sku || "N/A", // Use SKU as product name? Or is there a product name field?
        //     Category: categoryName,
        //     Price: `${item.selling_price || '0.00'} EGP`,
        //     // ADD THE IMAGE URL TO THE DATA OBJECT:
        //     image: imageUrl, // <--- Add the calculated image URL here
        //   };
        // });

        setTableData(response.data.data?.provider?.expiring_batches || []);
      })
      .catch((error) => {
        console.error("❌ Fetch failed:", error);
        // Set table data to empty array on error
        setTableData([]);
      });
  }, [id]);

  const col = [
    {
      name: "Product ID",
      selector: (row) => <div className="clac">{row.id}</div>,
      sortable: true,
    },
    {
      name: "Product Name",
      selector: (row) => (
        <div
          className="ProdectNameModel_product"
          style={{ display: "flex", alignItems: "center" }}
        >
          {/* Use row.image if truthy, otherwise use the default Def image */}
          <img
            src={row.image || Def} // <-- This is the key change using Def
            alt={row.ProductName}
            style={{
              width: "20px",
              height: "20px",
              objectFit: "cover",
              marginRight: "10px",
            }}
            onError={(e) => {
              e.target.src = Def;
            }} // Optional: Fallback if the provided URL fails to load
          />
          <div>{row.ProductName}</div>
        </div>
      ),
      sortable: true,
      minWidth: "200px",
    },
    {
      name: "Category",
      selector: (row) => (
        <div
          className="ProdectNameModel_product"
          style={{ display: "flex", alignItems: "center" }}
        >
          {/* Use the getCategoryImage function for category icons */}
          <img
            src={getCategoryImage(row.Category)}
            alt={row.Category}
            style={{
              width: "20px",
              height: "20px",
              objectFit: "cover",
              marginRight: "10px",
            }}
          />
          <div>{row.Category}</div>
        </div>
      ),
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Price",
      selector: (row) => row.Price,
      sortable: true,
    },
  ];
  const columns = [
    {
      field: "id",
      headerName: "Product ID",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return <div>{params.row.id}</div>;
      },
    },
    {
      field: "sku",
      headerName: "Product Name",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <>
            <div className="d-flex align-items-center justify-content-center gap-1">
              <img
                className="service-icon"
                src={`${
                  params.row?.variation.profile_image_url
                    ? newImageUrl + params.row?.variation.profile_image_url
                    : defaultImage
                }`}
                alt=""
              />
              <p className="m-0">{params.row?.variation.sku}</p>
            </div>
          </>
        );
      },
    },
    {
      field: "category",
      headerName: "Category",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {},
    },
    {
      field: "original_price",
      headerName: "Price",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return <div>{params.row?.variation?.original_price}</div>;
      },
    },

    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {},
    },
  ];
  const paginationModel = { page: 0, pageSize: 10 };
  // const filteredData = tableData.filter((row) =>
  //   row.ProductName.toLowerCase().includes(searchForPermissions.toLowerCase()) ||
  //   row.id.toLowerCase().includes(searchForPermissions.toLowerCase())
  // );

  return (
    <>
      <div className="p-4 border rounded-2 my-1 min-vh-100">
        <div className="d-flex justify-content-between align-items-center custom-card-sm">
          <h5 className="d-flex align-items-center gap-2">
            Products
            <span className="table-length">{tableData.length}</span>
          </h5>

          <div className="input-group w-50  justify-content-end align-items-center rounded-2 ">
            <input
              type="text"
              className={
                "form-control  bg-transparent position-relative rounded "
              }
              placeholder={`Search`}
              value={searchForPermissions}
              onChange={(e) => setSearchForPermissions(e.target.value)}
            />
            <div className="position-absolute mx-2">
              <Search />
            </div>
          </div>
        </div>

        {/* <DataTable
        columns={columns}
        data={filteredData} // Use filteredData for the table
        pagination
        highlightOnHover
        responsive
        className="custom-table"
        selectableRows
        selectableRowsHighlight
        onSelectedRowsChange={(state) =>
          setSelectedRows(state.selectedRows.map((row) => row.id))
        }
        // Add a conditional message for no data
        noDataComponent={<div style={{ padding: '24px' }}>No products found for this supplier.</div>}
      /> */}
        <div className="data-grid-small my-4">
          <Paper sx={{ height: "auto", width: "100%" }}>
            <DataGrid
              autoHeight
              rows={tableData}
              columns={columns}
              initialState={{ pagination: { paginationModel } }}
              pageSizeOptions={[5, 10]}
              checkboxSelection
              sx={{ border: 0 }}
            />
          </Paper>
        </div>
      </div>
    </>
  );
}

export default Supplier_Products;
